import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  height: 2.5rem;
  gap: 1rem;
  margin-bottom: 1rem;

  .active {
    border-bottom: 3px solid var(--light-blue);
  }

  a {
    display: inline-block;
    color: var(--light-blue);
    text-decoration: none;
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid rgba(0,0,0,0.125);
    border-bottom: 3px solid  rgba(0, 0, 0, 0.025);
    -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;

    .flex-div {
      height: 100%;
      padding: 0.4rem 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &::after {
      content: '';
      display: block;
      width: 0;
      height: 3px;
      background: var(--light-blue);
      transition: width .5s;
    }

    &:hover::after {
      width: 100%;
    }

  }

  @media (max-width: 720px) {
    display: none;
  }
`;
